import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, TextField, IconButton } from '@mui/material';
import { Button } from '../../../components/Button/button';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

const EditMachineryPopup = ({
    open,
    onClose,
    editMachineryData,
    setEditMachineryData,
    editSubCategoryData,
    setEditSubCategoryData,
    handleEditMachinery,
    loading,
    translations,
    language
}) => {
    const [subCategories, setSubCategories] = useState([]);

    const addSubCategory = () => {
        setSubCategories([...subCategories, '']);
    };

    useEffect(() => {
        // Convert string to array if it's not already an array
        if (editSubCategoryData) {
            const subCategoryArray = Array.isArray(editSubCategoryData)
                ? editSubCategoryData
                : [editSubCategoryData];
            setSubCategories(subCategoryArray);
        }
    }, [editSubCategoryData]);

    const handleSubCategoryChange = (index, value) => {
        const newSubCategories = [...subCategories];
        newSubCategories[index] = value;
        setSubCategories(newSubCategories);
        setEditSubCategoryData(newSubCategories);
    };

    const removeSubCategory = (index) => {
        const newSubCategories = subCategories.filter((_, i) => i !== index);
        setSubCategories(newSubCategories);
        setEditSubCategoryData(newSubCategories);
    };

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            fullWidth
            disableScrollLock
            PaperProps={{
                sx: { borderRadius: "12px" },
            }}
        >
            <div className="assign-div">
                <div className="d-flex justify-content-around align-items-center">
                    <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                        {translations[language].editMachinery}
                    </h5>
                </div>
            </div>
            <DialogContent>
                <form noValidate autoComplete="off">
                    <TextField
                        fullWidth
                        label={translations[language].enterMachinery}
                        value={editMachineryData}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 50) {
                                setEditMachineryData(value);
                            }
                        }}
                        inputProps={{
                            maxLength: 50,
                        }}
                        className="mb-3"
                    />

                    {subCategories.map((subCategory, index) => (
                        <div key={index} className="d-flex align-items-center gap-2 mb-3" style={{ position: 'relative' }}>
                            <TextField
                                fullWidth
                                label={translations[language].enterSubCategory}
                                value={subCategory}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value.length <= 50) {
                                        handleSubCategoryChange(index, value);
                                    }
                                }}
                                inputProps={{
                                    maxLength: 50,
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        paddingRight: '40px'
                                    }
                                }}
                            />
                            <IconButton
                                onClick={() => removeSubCategory(index)}
                                size="small"
                                sx={{
                                    position: 'absolute',
                                    right: '8px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    padding: '4px',
                                    minWidth: '20px',
                                    minHeight: '20px',
                                    borderRadius: '50%',
                                }}
                            >
                                <CloseIcon sx={{
                                    fontSize: 24,
                                    color: '#ffffff',
                                    backgroundColor: '#3c4856',
                                    borderRadius: '50%',
                                    padding: '2px'
                                }} />
                            </IconButton>
                        </div>
                    ))}

                    <div className="mb-3 d-flex align-items-center gap-2">
                        <IconButton
                            onClick={addSubCategory}
                            size="small"
                            sx={{
                                color: '#ffffff',
                                backgroundColor: '#3c4856',
                                borderRadius: '50%',
                                padding: '1px',
                                '&:hover': {
                                    backgroundColor: '#3c4856'
                                },
                            }}
                        >
                            <AddIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                        <span style={{ fontSize: '14px' }}>
                            {translations[language].subCategory}
                        </span>
                    </div>

                    <div className="d-flex gap-3 mt-2">
                        <button className="cancel-button" onClick={onClose}>
                            {translations[language].cancel}
                        </button>
                        <Button
                            title={translations[language].updateMachinery}
                            classname={"assign-task-button"}
                            onClick={handleEditMachinery}
                            loading={loading}
                        />
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default EditMachineryPopup;